import React, { useState } from "react";
import styled from "styled-components";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { WrapperErrorMessage, ErrorMessage } from "theme/CommonStyle"; //[cite: 2]

interface IInput {
  label?: React.ReactNode;
  height?: number;
  width?: number | string;
  fs?: number;
  fw?: number;
  lh?: string;
  fsLabel?: number;
  fwLabel?: number;
  lhLabel?: string;
  value?: string;
  name?: string;
  type?: string;
  onChange?: any;
  error?: string;
  marginForm?: string;
  bdr?: any;
  ref?: any;
  placeholder?: string;
  disabled?: boolean;
  onBlur?: any;
  maxLength?: any;
  autoComplete?: string;
  defaultValue?: any;
  padding?: string;
  style?: any;
  hasPasswordToggle?: boolean;
}

const FormControl = styled.div<IInput>(({ marginForm }) => ({
  position: "relative",
  margin: marginForm,
}));

const Label = styled.div<IInput>(({ theme, fsLabel, fwLabel, lhLabel }) => ({
  color: theme.colors.text.primary,
  fontSize: fsLabel || theme.sizes.xs,
  fontWeight: fwLabel || 400,
  lineHeight: lhLabel || "12px",
  marginBottom: 8,
}));

const InputStyled = styled.input<IInput>(
  ({ theme, width, height, fs, fw, bdr, padding, lh }) => ({
    height: height || 40,
    width: width || "100%",
    borderRadius: bdr || 6,
    boxShadow: "inset 0px 2px 4px rgba(0, 0, 0, 0.09)",
    border: `1px solid ${theme.colors.border}`,
    fontSize: fs || theme.sizes.sm,
    fontWeight: fw || theme.fontWeight.medium,
    lineHeight: lh || "20px",
    padding: padding || "0px 11px",
    outline: "none",
    ":focus": {
      border: `1px solid ${theme.colors.outline}`,
    },
    "::placeholder": {
      color: theme.colors.icon,
    },
  })
);

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const IconWrapper = styled.div`
  position: absolute;
  right: 12px;
  cursor: pointer;
  color: #3b3b3b;
  display: flex;
  align-items: center;
  font-size: 16px;
  transition: color 0.3s;
`;

const Input: React.FC<IInput> = ({
  label,
  error,
  fsLabel,
  fwLabel,
  lhLabel,
  marginForm,
  defaultValue,
  autoComplete,
  type,
  hasPasswordToggle,
  padding,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const inputType = hasPasswordToggle
    ? showPassword
      ? "text"
      : "password"
    : type;

  const computedPadding = hasPasswordToggle ? "0px 36px 0px 11px" : padding;

  return (
    <FormControl marginForm={marginForm}>
      {label && (
        <Label fsLabel={fsLabel} fwLabel={fwLabel} lhLabel={lhLabel}>
          {label}
        </Label>
      )}
      <InputWrapper>
        <InputStyled
          {...rest}
          type={inputType}
          padding={computedPadding}
          spellCheck="false"
          autoComplete={autoComplete}
          defaultValue={defaultValue}
        />
        {hasPasswordToggle && (
          <IconWrapper onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
          </IconWrapper>
        )}
      </InputWrapper>
      {error && (
        <WrapperErrorMessage>
          <ErrorMessage>{error}</ErrorMessage>
        </WrapperErrorMessage>
      )}
    </FormControl>
  );
};

export default Input;
